import { Component } from '@angular/core';
import { BaseComponent } from '@pit/core';
import { PinItTrackFrontendServicesAccessor } from '@pit/frontend-shared';

@Component({
    selector: 'pin-it-track-web-app-menu-right',
    templateUrl: './pin.it.track.web.app.menu.right.component.html',
    styleUrls: ['./pin.it.track.web.app.menu.right.component.scss']
})
export class PinItTrackWebAppMenuRightComponent extends BaseComponent {

    constructor(public readonly servicesAccessor: PinItTrackFrontendServicesAccessor) {
        super(servicesAccessor.coreServicesAccessor.applicationService as any);
    }

}
